export const invalidPhoneNumberCharactersRegex = /[^\d+]|(?!^)\+/g;
